<app-header-style-one></app-header-style-one>
<router-outlet></router-outlet>
<div class="bg-img-main">
    <app-footer></app-footer>
</div>